//本地接口
import localServer from "@/utils/request.js"
import { get } from "js-cookie";
const qs = require("qs");
const API_SIM = {
    //获取用户sim卡接口
    FETCH_ALL_SIMCARD: function (data) {
        return localServer({
            url: "user/sim/",
            method: "get",
            headers: { "cache-control": "no-cache" },
            params: data
        })
    },
    // //更新到期时间
    // updateApi: function (data) {
    //     return localServer({
    //         url: "user/sim/excel/",
    //         method: "put",
    //         headers: { "cache-control": "no-cache" },
    //         data: data
    //     })
    // },
    //更新到期时间
    updateApi: function (formdata) {
        if (formdata instanceof Object) {
            return localServer({
                url: "user/sim/excel/",
                method: "put",
                data: formdata
            })
        } else if (formdata instanceof FormData) {
            return localServer({
                url: "user/sim/excel/",
                method: "post",
                dataType: 'formData',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formdata
            })
        }
    },
    //更新到期时间
    update2Api: function (data) {
        return localServer({
            url: "user/sim/expirationdate/",
            method: "put",
            headers: { "cache-control": "no-cache" },
            data: data
        })
    },
    //添加备注
    beizhuApi: function (id, data) {
        return localServer({
            url: `sim/detail/${id}/`,
            method: "put",
            headers: { "cache-control": "no-cache" },
            data: data
        })
    },
    //更新套餐
    updateMealApi: function (data) {
        return localServer({
            url: "user/sim/excelpackage/",
            method: "put",
            headers: { "cache-control": "no-cache" },
            data: data
        })
    },
    //更新套餐
    updateMeal2Api: function (data) {
        return localServer({
            url: "user/sim/package/",
            method: "put",
            headers: { "cache-control": "no-cache" },
            data: data
        })
    },
    //导出sim卡
    EXPORT_SIM: function (data) {
        return localServer({
            url: "user/sim/export/",
            method: "get",
            params: data
        })
    },
    QUERY_CPY: function (data) {
        return localServer({
            url: "user/sim/queryCpy/",
            method: "post",
            data: data
        })
    },
    //获取SIM卡详情
    FETCH_SIMCARD_DETAIL: function (number) {
        return localServer({
            url: `sim/detail/${number}/`,
            method: "get",
        })
    },
    // 获取用户首页接口
    FETCH_HOMEPAGE: function () {
        return localServer({
            url: "user/homepage/",
            method: "get"
        })
    },
    //导入用户SIM卡接口
    IMPORT_USER_SIM: function (formdata) {
        if (formdata instanceof Object) {
            return localServer({
                url: "user/sim/",
                method: "post",
                data: formdata
            })
        } else if (formdata instanceof FormData) {
            return localServer({
                url: "user/sim/",
                method: "post",
                dataType: 'formData',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formdata
            })
        }
    },
    // 获取导入用户模板
    FETCH_USER_SIM_TEMPLATE: function () {
        return localServer({
            url: "user/sim/download/",
            method: "get",
            responseType: "blob",
        })
    },
    //获取子用户sim卡接口
    FETCH_KIDUSER_SIM: function () {
        return localServer({
            url: `kiduser/${id}/sim`,
            method: "get"
        })
    },
    //导入子用户sim卡接口
    IMPORT_KIDUSER_SIM: function (id, formdata) {
        if (formdata instanceof Object) {
            return localServer({
                url: `kiduser/${id}/sim/`,
                method: 'post',
                data: formdata
            })
        } else if (formdata instanceof FormData) {
            return localServer({
                url: `kiduser/${id}/sim/`,
                method: 'post',
                dataType: 'formData',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formdata
            })
        }
    },
    //下载子用户sim卡模板接口
    DOWNLOAD_KIDUSER_USER: function () {
        return localServer({
            url: "kiduser/sim/download/",
            method: "get",
            responseType: "blob"
        })
    },
    //获取单一用户sim卡接口
    FETCH_ONE_SIM: function (userid, simkid) {
        return localServer({
            url: `kiduser/${userid}/sim/${simid}/`,
            method: "get"
        })
    },
    //获取sim卡流量预警
    FETCH_SIM_ALERT: function (msisdn) {
        return localServer({
            url: "user/simalarm/",
            method: "get",
            params: {
                msisdn: msisdn
            }
        })
    },
    //设置sim卡流量预警
    SET_SIM_ALERT: function (obj) {
        let { msisdn, alarm1, alarm2, alarm3, is_alarm } = obj;
        is_alarm = parseInt(is_alarm);
        return localServer({
            url: "user/simalarm/",
            method: "post",
            data: {
                msisdn,
                alarm1,
                alarm2,
                alarm3,
                is_alarm
            }
        })
    },
    //检查是否为本公司的SIM卡
    //TODO
    CHECK_US_CARD: function () {
        return localServer({
            url: "/sim/check/",
            method: "get",
            params: {}
        })
    },
    // SIM卡列表预到期提醒
    // 获取列表查询 + 模糊查询
    GET_SIMLIST_NOTICE: function (query) {
        console.log(query);
        return localServer({
            url: "/sim/notice/",
            method: "get",
            params: {
                email: query
            }
        })
    },
    //
    // SIM卡列表预到期提醒
    // 添加邮箱
    ADD_SIMNOTICE_EMAIL: function (form) {
        return localServer({
            url: "/sim/notice/",
            method: "post",
            data: {
                email: form.email,
                notice_id: form.saleman
            }
        })
    },
    // SIM卡列表预到期提醒
    // 删除邮箱
    DELETE_SIMNOTICE_EMAIL: function (id, email) {
        return localServer({
            url: `/sim/notice/${id}/`,
            method: "DELETE"
        })
    },
    // 获取级联数据
    GET_MESSAGE: function () {
        return localServer({
            url: "/user/sim/message/",
            method: "post"
        })
    },
    GET_ORIGINCARD: function () {
        return localServer({
            url: "/user/cardcompanys/",
            method: "get"
        })
    }
}

export default API_SIM



// WEBPACK FOOTER //
// ./src/api/Sim.js